var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{staticClass:"lg:w-auto w-full",on:{"click":_vm.changePasswordHandler}},[_vm._v("Change Password")])
}
var staticRenderFns = []

export { render, staticRenderFns }